import {ActivatedRoute, ActivatedRouteSnapshot, createUrlTreeFromSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {inject} from '@angular/core';

/**
 *  Generates a fallback route as UrlTree depending on the config passed using the route data.
 *  There are several possible cases that are handled in this order:
 *
 *  1. If provided with an absolute fallback route, named 'fallbackRoute' , this route is used.
 *  2. If provided with a relative fallback route, named 'fallbackRouteRelative', redirects to
 *      the originally intended route, with the last segment replaced with the fallbackRouteRelative.
 *      E.g. when trying to reach '/projects/foo' and using fallbackRouteRelative 'bar', redirects to '/projects/foo/bar'
 *           when trying to reach '/projects/foo' and using fallbackRouteRelative '../bar', redirects to '/projects/bar'
 *  3. If provided with a default as a parameter, this route is used as an absolute fallback route
 *  4. If none of the cases above is chosen, it redirects to the first parent route.
 *      E.g. for the path '/projects/foo' it redirects to '/projects'
 *
 * */
export function generateFallbackRoute(state: RouterStateSnapshot, route: ActivatedRouteSnapshot, router: Router, optDefault?: string) {
    let fallbackRoute = state.url.split('/').slice(0, -1).join('/');
    if (route.data.fallbackRoute) {
        fallbackRoute = route.data.fallbackRoute;
    } else if (route.data.fallbackRouteRelative) {
        return createUrlTreeFromSnapshot(route, [route.data.fallbackRouteRelative]);
    } else if (optDefault) {
        fallbackRoute = optDefault;
    }
    return router.createUrlTree([fallbackRoute]);
}
